import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import Sidebar from '../../components/Donation/Sidebar';
import DonationForm from '../../components/Donation/Form/DonationForm';
import DonationSubmitting from '../../components/Donation/DonationSubmitting';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import accounting from 'accounting';
import CssTransition from '../../components/Transition/CssTransition';
import { TransitionGroup } from 'react-transition-group';

import OverlayPartner from '../Widget/OverlayPartner';
import {
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { CardTypes, PaymentMethod } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';

import {
    mobileGoWizardStep,
    onBackToAmount,
    setupApplePay,
    setupGooglePay,
    setupVenmo,
    submitDonationCreditCard,
    toggleCreditCardForm,
    displayInvalidTokenIdError
} from './actions';

import getIsLegacyDonation from '../../utils/donation/isLegacyDonation';


const DonationDetailsContainer = styled.div`
    display: ${props => (props.isVisible ? 'flex' : 'none')};
    flex-direction: row;
    flex: 1;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    background-color: white;
`;

class DonationDetails extends React.Component {
    static propTypes = {
        actionIdentifier: PropTypes.string.isRequired,
        activeAction: PropTypes.object.isRequired,
        amountFormated: PropTypes.string.isRequired,
        apiRequestData: PropTypes.object.isRequired,
        donationSubmitError: PropTypes.string,
        feedbackText: PropTypes.string.isRequired,
        formValues: PropTypes.object,
        isMobileResolution: PropTypes.bool.isRequired,
        isMultiActionsCard: PropTypes.bool.isRequired,
        isSubmitting: PropTypes.bool.isRequired,
        mobileGoWizardStep: PropTypes.func.isRequired,
        mobileWizardStep: PropTypes.number,
        onBackToAmount: PropTypes.func.isRequired,
        partnerLogo: PropTypes.string,
        partnerName: PropTypes.string.isRequired,
        paymentInfo: PropTypes.object.isRequired,
        paymentMethod: PropTypes.string.isRequired,
        selectedAmountTime: PropTypes.instanceOf(Date),
        setExitingCardProps: PropTypes.func.isRequired,
        setOverlayPartnerVisible: PropTypes.func.isRequired,
        setupApplePay: PropTypes.func.isRequired,
        setupGooglePay: PropTypes.func.isRequired,
        setupVenmo: PropTypes.func.isRequired,
        showCreditCardForm: PropTypes.bool.isRequired,
        submitDonationCreditCard: PropTypes.func.isRequired,
        supportedNativePaymentTypes: PropTypes.arrayOf(PropTypes.number.isRequired)
            .isRequired,
        toggleCreditCardForm: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.initializeNativePaymentMethods();
    }

    initializeNativePaymentMethods() {
        this.props.setupApplePay();
        this.props.setupGooglePay(this.props.paymentMethod);
        this.props.setupVenmo(this.props.paymentInfo);
    }

    render() {
        return (
            <TransitionContainer zIndex={12} isSubmitting={this.props.isSubmitting}>
                <Container>
                    <TransitionGroup>
                        {this.props.donationSubmitError && (
                            <CssTransition
                                key="alert"
                                in={this.props.donationSubmitError}
                            >
                                <ToasterAlert content={this.props.donationSubmitError} />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                    <TransitionGroup>
                        {this.props.isSubmitting && (
                            <CssTransition
                                key="loading"
                                in={this.props.isSubmitting}
                                timeoutInMs={650}
                            >
                                <TransitionContainerNoExit noAnimation={true}>
                                    <DonationSubmitting
                                        isMobileResolution={this.props.isMobileResolution}
                                    />
                                </TransitionContainerNoExit>
                            </CssTransition>
                        )}
                    </TransitionGroup>
                    <OverlayPartner transitionType="left-to-right" />
                    <DonationDetailsContainer isVisible={!this.props.isSubmitting}>
                        {!this.props.isMobileResolution && (
                            <Sidebar
                                amount={this.props.amountFormated}
                                hasChoiceOfPaymentProvider={
                                    this.props.supportedNativePaymentTypes.length > 1 &&
                                    this.props.paymentMethod !== PaymentMethod.GlobalGiving
                                }
                                isLegacyDonation={this.props.isLegacyDonation}
                                partnerLogo={this.props.partnerLogo}
                                paymentMethod={this.props.paymentMethod}
                                onPartnerClick={() =>
                                    this.props.setOverlayPartnerVisible(true)
                                }
                                toggleCreditCardForm={this.props.toggleCreditCardForm}
                                showCreditCardForm={this.props.showCreditCardForm}
                            />
                        )}
                        <DonationForm
                            isMobileResolution={this.props.isMobileResolution}
                            onBackToAmount={() => {
                                this.props.setExitingCardProps(
                                    'donation',
                                    this.props,
                                    this.props.activeAction
                                );
                                this.props.onBackToAmount();
                            }}
                            amountFormated={this.props.amountFormated}
                            mobileWizardStep={this.props.mobileWizardStep}
                            mobileGoWizardStep={this.props.mobileGoWizardStep}
                            partnerLogo={this.props.partnerLogo}
                            partnerName={this.props.partnerName}
                            paymentMethod={this.props.paymentMethod}
                            supportedNativePaymentTypes={
                                this.props.supportedNativePaymentTypes
                            }
                            hasChoiceOfPaymentProvider={
                                this.props.supportedNativePaymentTypes.length > 1 &&
                                this.props.paymentMethod !== PaymentMethod.GlobalGiving
                            }
                            onPartnerClick={() =>
                                this.props.setOverlayPartnerVisible(true)
                            }
                            onSubmit={(e, isOrgHunterDonation, nonce) => {
                                e.preventDefault();
                                if (isOrgHunterDonation && !nonce){
                                    this.props.displayInvalidTokenIdError();
                                    return;
                                }
                                this.props.submitDonationCreditCard(
                                    nonce,
                                    this.props.apiRequestData,
                                    this.props.paymentInfo,
                                    this.props.formValues,
                                    this.props.paymentMethod,
                                    this.props.selectedAmountTime,
                                    this.props.isMultiActionsCard,
                                    this.props.actionIdentifier,
                                    this.props.feedbackText,
                                    this.props.partnerName
                                );
                            }}
                            onComplete={() => {
                                this.props.setExitingCardProps(
                                    'donation',
                                    this.props,
                                    this.props.activeAction
                                );
                            }}
                        />
                    </DonationDetailsContainer>
                </Container>
            </TransitionContainer>
        );
    }
}

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'donation',
            ['/donation/details'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            amount: state.donation.selectedAmount,
            amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0),
            apiRequestData: state.widget.apiRequestData,
            paymentInfo: state.donation.paymentInfo,
            cards: state.widget.cards,
            donationSubmitError: state.donation.donationSubmitError,
            feedbackText: state.widget.activeAction.thankYouText || '',
            isLegacyDonation: getIsLegacyDonation(state),
            isMobileResolution: state.widget.isMobileResolution,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isSubmitting: state.donation.isSubmitting,
            formValues: (state.form.donationForm || {}).values,
            mobileWizardStep: state.donation.mobileWizardStep,
            partnerLogo: state.widget.activeAction.partner.logoUrl,
            partnerName: state.widget.activeAction.partner.name,
            paymentMethod: state.widget.activeAction.partner.paymentMethod,
            selectedAmountTime: state.donation.selectedAmountTime,
            showCreditCardForm: state.donation.showCreditCardForm,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
            supportedNativePaymentTypes: state.donation.supportedNativePaymentTypes
        };
    },
    {
        mobileGoWizardStep,
        onBackToAmount,
        setExitingCardProps,
        setOverlayPartnerVisible,
        setupApplePay,
        setupGooglePay,
        setupVenmo,
        submitDonationCreditCard,
        toggleCreditCardForm,
        displayInvalidTokenIdError
    }
)(DonationDetails);
